import { CommonModule, NgOptimizedImage } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faXmark } from '@fortawesome/pro-light-svg-icons';
import { faBell, faChevronRight, faMinus, faPlus } from '@fortawesome/pro-regular-svg-icons';
import {
  BannerModule,
  BreadcrumbsModule,
  GenericCarouselModule,
  GenericListModule,
} from '@motivforce/mx-library-angular';
import { NgbDatepickerModule, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { NgxSpinnerModule } from 'ngx-spinner';

import { AccentRowComponent } from './components/accent-row/accent-row.component';
import { AccountSummaryWidgetComponent } from './components/account-summary-widget/account-summary-widget.component';
import { ActionBoxComponent } from './components/action-box/action-box.component';
import { BackToLinkComponent } from './components/back-to-link/back-to-link.component';
import { BannerComponent } from './components/banner/banner.component';
import { CarouselSliderComponent } from './components/carousel-slider/carousel-slider.component';
import { CartSummaryWidgetComponent } from './components/cart-summary-widget/cart-summary-widget.component';
import { CartWidgetComponent } from './components/cart-widget/cart-widget.component';
import { CountdownComponent } from './components/countdown/countdown.component';
import { CustomListComponent } from './components/custom-list/custom-list.component';
import { CustomProductListComponent } from './components/custom-product-list/custom-product-list.component';
import { DefaultMainLayoutComponent } from './components/default-main-layout/default-main-layout.component';
import { ImageSliderPuzzleComponent } from './components/image-slider-puzzle/image-slider-puzzle.component';
import { LoadingIndicatorComponent } from './components/loading-indicator/loading-indicator.component';
import { LogoComponent } from './components/logo/logo.component';
import { ModalOpenPaddingWrapperComponent } from './components/modal-open-padding-wrapper/modal-open-padding-wrapper.component';
import { PromotionAnimatedButtonComponent } from './components/promotion-animated-button/promotion-animated-button.component';
import { PromotionBoxComponent } from './components/promotion-box/promotion-box.component';
import { PublicMainLayoutComponent } from './components/public-main-layout/public-main-layout.component';
import { UnauthMainLayoutComponent } from './components/unauth-main-layout/unauth-main-layout.component';
import { UnauthPassportFormComponent } from './components/unauth-passport-form/unauth-passport-form.component';
import { WidgetMainLayoutComponent } from './components/widget-main-layout/widget-main-layout.component';
import { MinutesSecondsPipe } from './pipes/minutes-seconds.pipe';

@NgModule({
  declarations: [
    LogoComponent,
    LoadingIndicatorComponent,
    AccountSummaryWidgetComponent,
    MinutesSecondsPipe,
    ModalOpenPaddingWrapperComponent,
    ImageSliderPuzzleComponent,
    PromotionAnimatedButtonComponent,
    DefaultMainLayoutComponent,
    WidgetMainLayoutComponent,
    CarouselSliderComponent,
    PromotionBoxComponent,
    ActionBoxComponent,
    CartWidgetComponent,
    CustomListComponent,
    CustomProductListComponent,
    AccentRowComponent,
    BackToLinkComponent,
    PublicMainLayoutComponent,
    BannerComponent,
    CountdownComponent,
    UnauthMainLayoutComponent,
    UnauthPassportFormComponent,
    CartSummaryWidgetComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    RouterModule,
    FontAwesomeModule,
    ReactiveFormsModule,
    NgbDatepickerModule,
    NgxSpinnerModule,
    NgbDropdownModule,
    GenericCarouselModule,
    BannerModule,
    TranslateModule,
    BreadcrumbsModule,
    GenericListModule,
    NgOptimizedImage,
    TranslateModule,
  ],
  exports: [
    LogoComponent,
    LoadingIndicatorComponent,
    AccountSummaryWidgetComponent,
    MinutesSecondsPipe,
    ModalOpenPaddingWrapperComponent,
    ImageSliderPuzzleComponent,
    PromotionAnimatedButtonComponent,
    DefaultMainLayoutComponent,
    CarouselSliderComponent,
    CartWidgetComponent,
    PromotionBoxComponent,
    ActionBoxComponent,
    CartWidgetComponent,
    CustomListComponent,
    CustomProductListComponent,
    AccentRowComponent,
    BackToLinkComponent,
    PublicMainLayoutComponent,
    BannerComponent,
    CountdownComponent,
    UnauthMainLayoutComponent,
    UnauthPassportFormComponent,
    CartSummaryWidgetComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule {
  constructor(private iconlibrary: FaIconLibrary) {
    this.iconlibrary.addIcons(faBell, faChevronRight, faMinus, faPlus, faXmark);
  }
}
